<template>
  <footer class="text-muted footer mt-auto py-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center text-sm-start col-sm-4">
          {{ new Date().getFullYear() }} © Innovationworx GmbH
        </div>
        <div class="col-12 text-center text-sm-start col-sm-4">v.{{ version }}</div>
        <div class="col-12 col-sm-4">
          <div class="text-center text-sm-end footer-links">
            <a
              v-if="['root', 'Orga-Manager', 'Admin'].includes($store.state.me.grp_name_bez)"
              href="mailto:feedback@real-time-plants.de"
              >Feedback senden</a
            >
            <span
              v-if="['root', 'Orga-Manager', 'Admin'].includes($store.state.me.grp_name_bez)"
              class="mx-1"
              >·</span
            >
            <router-link to="/impressum">{{ $t('Impressum') }}</router-link>
            <span class="mx-1">·</span>
            <router-link to="/privacy">Datenschutz</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      version: process.env.VUE_APP_VERSION || 'dev',
    };
  },
};
</script>

<style></style>
